import { ViewOffIcon } from '@chakra-ui/icons';
import {
    Box,
    FormControl,
    FormLabel,
    HStack,
    Input,
    InputGroup,
    InputRightElement,
    Stack,
    Tab,
    TabList,
    Tabs,
    Text,
} from '@chakra-ui/react';

import ImageLoader from '../../../../components/v4/ImageLoader';
import { TcapLink } from '@/v5/components/atoms/Link/TcapLink';
import { LoginButtonGroup } from '@/v5/components/molecules/ButtonGroup/LoginButtonGroup';

import './fakelogin.css';

export default function FakeLogin({
    logo,
    email,
    dataWalkthroughId,
    backgroundImage,
}) {
    return (
        <Box
            className="fakelogin"
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '600px',
                margin: '20px auto',
                overflow: 'hidden',
                borderRadius: '8px',
                boxShadow:
                    '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
            }}
            data-walkthroughid={dataWalkthroughId}>
            {/* LEFT SIDE - Background Image */}
            <Box
                flex={1.5}
                style={{
                    backgroundImage:
                        backgroundImage ||
                        'url(https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1000)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            />

            {/* RIGHT SIDE - Login Form */}
            <Box
                flex={1}
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    background: 'white',
                    padding: '48px 64px',
                    overflowY: 'auto',
                }}>
                {/* Logo */}
                <Box sx={{ height: '80px', marginBottom: '40px' }}>
                    <ImageLoader
                        image={logo}
                        objectProps={{
                            alt: 'Domain Logo',
                            style: {
                                display: 'block',
                                maxWidth: '240px',
                                maxHeight: '100%',
                                margin: '0 auto',
                            },
                            type: 'image/svg+xml',
                        }}
                        imageProps={{
                            sx: {
                                display: 'block',
                                maxWidth: '240px',
                                maxHeight: '100%',
                                margin: '0 auto',
                            },
                        }}
                    />
                </Box>

                {/* Tabs */}
                <Tabs index={0} mb={6}>
                    <TabList borderBottom="2px solid" borderColor="gray.200">
                        <Tab
                            flex={1}
                            _selected={{
                                color: 'messenger.500',
                                borderBottom: '2px solid',
                                borderColor: 'messenger.500',
                            }}
                            fontWeight="500"
                            pb={3}
                            color="gray.600">
                            Login
                        </Tab>
                        <Tab
                            flex={1}
                            _selected={{
                                color: 'messenger.500',
                                borderBottom: '2px solid',
                                borderColor: 'messenger.500',
                            }}
                            fontWeight="500"
                            pb={3}
                            color="gray.600">
                            Register
                        </Tab>
                    </TabList>
                </Tabs>

                <Stack spacing="4">
                    {/* Email Field */}
                    <FormControl mb={4}>
                        <FormLabel
                            htmlFor="login-username"
                            fontSize="sm"
                            fontWeight="400"
                            color="gray.700"
                            mb={2}>
                            Email{' '}
                            <Text as="span" color="red.500">
                                *
                            </Text>
                        </FormLabel>
                        <Input
                            value={email}
                            placeholder="Enter your email"
                            variant="outline"
                            borderColor="gray.300"
                            size="md"
                            id="login-username"
                            color="gray.900"
                            _hover={{ borderColor: 'gray.400' }}
                            _focus={{
                                borderColor: 'messenger.500',
                                boxShadow: '0 0 0 1px #007BFF',
                            }}
                            borderRadius="md"
                        />
                    </FormControl>

                    {/* Password Field */}
                    <FormControl mb={3}>
                        <FormLabel
                            htmlFor="login-password"
                            fontSize="sm"
                            fontWeight="400"
                            color="gray.700"
                            mb={2}>
                            Password{' '}
                            <Text as="span" color="red.500">
                                *
                            </Text>
                        </FormLabel>
                        <InputGroup>
                            <Input
                                value=""
                                placeholder="Enter your password"
                                borderColor="gray.300"
                                variant="outline"
                                size="md"
                                type="password"
                                id="login-password"
                                color="gray.900"
                                _hover={{ borderColor: 'gray.400' }}
                                _focus={{
                                    borderColor: 'messenger.500',
                                    boxShadow: '0 0 0 1px #007BFF',
                                }}
                                borderRadius="md"
                            />
                            <InputRightElement>
                                <ViewOffIcon color="gray.400" />
                            </InputRightElement>
                        </InputGroup>
                    </FormControl>

                    <HStack role="group" justify="flex-end">
                        <TcapLink to="/forgot-password">
                            Forgot password?
                        </TcapLink>
                    </HStack>

                    <Stack
                        role="group"
                        spacing="4"
                        aria-label="buttons container">
                        <LoginButtonGroup
                            isSubmitting={false}
                            isChecked={false}
                            setShowError={() => {}}
                        />
                    </Stack>
                </Stack>

                {/* Copyright Footer */}
                <Text fontSize="sm" color="gray.600" textAlign="center" mt={8}>
                    © {new Date().getFullYear()} TCAP. All rights reserved.
                </Text>
            </Box>
        </Box>
    );
}
